import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import SectionHeading from "@/components/base/SectionHeading";
import HeroCarousel from "./components/HeroCarousel";
import CategoryGrid from "./components/CategoryGrid";
import LatestSection from "./components/LatestSection";
import HotSection from "./components/HotSection";
import IntroStrip from "./components/IntroStrip";
import { videos } from "@/mocks/videos";
import { articles } from "@/mocks/articles";
import { posts } from "@/mocks/posts";
import usePageMeta from "@/hooks/usePageMeta";

export default function Home() {
  usePageMeta(
    "挠脚心网站-趣味互动与挠痒体验平台",
    "挠脚心网站为您提供丰富的挠痒互动趣味内容，涵盖视频、文章和社区交流，带来轻松愉快的娱乐体验。",
    "挠脚心网站,挠脚心趣味,挠痒互动,挠痒视频,挠痒体验,娱乐趣味,轻松娱乐"
  );

  const latestVideos = [...videos].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 3);
  const latestArticles = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 3);
  const latestPosts = [...posts].sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1)).slice(0, 3);

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <HeroCarousel />

        <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
          <section className="pt-12 md:pt-16" aria-label="快捷分类入口">
            <SectionHeading
              kicker="从这里开始"
              title="三个入口，挑一个顺眼的"
              description="想看短视频、想读点东西，或者想找人聊两句，都可以在这里找到方向。"
            />
            <CategoryGrid />
          </section>

          <section className="pt-12 md:pt-16" aria-label="最新发布内容">
            <SectionHeading
              kicker="刚刚更新"
              title="最新发布内容"
              description="视频、文章和社区帖子三个板块同步更新，内容均为演示数据。"
            />
            <LatestSection
              videos={latestVideos}
              articles={latestArticles}
              posts={latestPosts}
            />
          </section>

          <section className="pt-12 md:pt-16" aria-label="热门推荐">
            <SectionHeading
              kicker="大家都在看"
              title="热门推荐"
              description="按站内热度整理的推荐内容，切换标签可以查看视频或文章榜单。"
            />
            <HotSection videos={videos} articles={articles} />
          </section>

          <section className="pt-12 md:pt-16" aria-label="网站简介">
            <IntroStrip />
          </section>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}